import { useNavigate } from "react-router-dom";
import { Activity, AlertCircle, CalendarClock, CalendarDays, ChevronRight, ClipboardList, CreditCard, Mic, Users, WalletCards } from "lucide-react";
import { inr, today, useCan, useLoad } from "@/lib/api";

export default function Dashboard() {
  const navigate = useNavigate();
  const can = useCan();
  const { data: stats } = useLoad(`/dashboard?day=${today()}`, { patients: 0, visits: 0, pending_reviews: 0, collections: 0, outstanding: 0 });
  const cards = [
    ["Patients", stats.patients, "in your clinic register", Users, "teal", "stat-patients"],
    ["Clinical visits", stats.visits, "documented records", ClipboardList, "yellow", "stat-visits"],
    ["To review", stats.pending_reviews, "voice drafts waiting", Mic, "rose", "stat-pending"],
    can("ledger:read") && ["Collected today", inr(stats.collections), "payments minus refunds", WalletCards, "blue", "stat-collections"],
    can("appointments:read") && ["Appointments today", stats.appointments_today || 0, "booked for today", CalendarDays, "teal", "stat-appointments-today"],
    can("appointments:read") && ["Overdue follow-ups", stats.overdue_followups || 0, "need attention", CalendarClock, "yellow", "stat-overdue-followups"],
    can("ledger:read") && ["Outstanding", inr(stats.outstanding), "across all patients", AlertCircle, "rose", "stat-outstanding"],
  ].filter(Boolean);
  const actions = [
    ["Add or find a patient", Users, "/patients", "patients:read"],
    ["Start a voice entry", Mic, "/voice", "voice"],
    ["Record a payment", CreditCard, "/payments", "payments:write"],
    ["Book a follow-up", CalendarDays, "/appointments", "appointments:write"],
    ["Open today’s cashbook", WalletCards, "/cashbook", "cashbook:read"],
    ["Write a visit note", ClipboardList, "/clinical", "clinical:write"],
  ].filter((a) => can(a[3]));
  return (
    <div className="content">
      <div className="page-heading">
        <div><p className="eyebrow">{new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}</p><h1>Your clinic, <em>in rhythm.</em></h1><p className="muted">A clear view of today’s work, waiting decisions and patient care.</p></div>
        {can("voice") && <button className="primary" onClick={() => navigate("/voice")} data-testid="dashboard-start-voice-button"><Mic size={18} /> Start voice entry</button>}
      </div>
      <div className="stat-grid">
        {cards.map(([l, value, sub, Icon, color, tid]) => <div className="stat-card" key={l} data-testid={tid}><div className={`stat-icon ${color}`}><Icon size={19} /></div><div><span>{l}</span><strong>{value}</strong><small>{sub}</small></div></div>)}
      </div>
      <div className="dashboard-grid">
        <section className="welcome-panel">
          <div><p className="eyebrow light">THE FASTEST WAY TO DOCUMENT</p><h2>Say it naturally.<br /><em>We’ll structure the rest.</em></h2><p>Record a full patient interaction in English, Hindi or Hinglish. Review every extracted entry before it touches your ledger.</p>
            {can("voice") && <button className="ghost-light" onClick={() => navigate("/voice")} data-testid="welcome-voice-button">Open voice entry <ChevronRight size={16} /></button>}</div>
          <div className="panel-mic"><div><Mic size={31} /></div><span>READY WHEN<br />YOU ARE</span></div>
        </section>
        <section className="quick-panel">
          <div className="section-head"><div><p className="eyebrow">QUICK ACTIONS</p><h3>Keep the day moving</h3></div><Activity size={20} /></div>
          {actions.map(([l, Icon, go]) => <button className="quick-action" key={l} onClick={() => navigate(go)} data-testid={`quick-action-${go.slice(1)}`}><span><Icon size={17} /></span>{l}<ChevronRight size={16} /></button>)}
        </section>
      </div>
    </div>
  );
}
